"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoolingOffDuration = exports.setAllSelected = exports.setPicks = exports.setContest = exports.SET_IS_ALL_SELECTED = exports.SET_PICKS = exports.GET_PICKEMS_BETS = exports.GET_PICKEMS = exports.SET_CONTEST = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _reactUtils = require("@low6dev/react-utils");

var _reactToastify = require("react-toastify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { setToolbar } from "components/layout/toolbar/actions";
//import mockContest from "mocks/mockContestPosh.json";
var SET_CONTEST = "contest:SET_CONTEST";
exports.SET_CONTEST = SET_CONTEST;
var GET_PICKEMS = "contest:GET_PICKEMS";
exports.GET_PICKEMS = GET_PICKEMS;
var GET_PICKEMS_BETS = "contest:GET_PICKEMS_BETS";
exports.GET_PICKEMS_BETS = GET_PICKEMS_BETS;
var SET_PICKS = "contest:SET_PICKS";
exports.SET_PICKS = SET_PICKS;
var SET_IS_ALL_SELECTED = "contest:SET_IS_ALL_SELECTED";
exports.SET_IS_ALL_SELECTED = SET_IS_ALL_SELECTED;

var setContest = function setContest(contest) {
  return function (dispatch) {
    dispatch({
      type: SET_CONTEST,
      payload: contest
    });
  };
};

exports.setContest = setContest;

var setPicks = function setPicks(picks) {
  return function (dispatch, getState) {
    dispatch({
      type: SET_PICKS,
      payload: picks
    });
  };
};

exports.setPicks = setPicks;

var setAllSelected = function setAllSelected(value) {
  return function (dispatch) {
    dispatch({
      type: SET_IS_ALL_SELECTED,
      payload: {
        isAllSelected: value
      }
    });
  };
};

exports.setAllSelected = setAllSelected;

var getCoolingOffDuration = function getCoolingOffDuration() {
  return function (dispatch) {
    _axios.default.get("/cooling-off").then(function (_ref) {
      var data = _ref.data;
      dispatch(setContest({
        coolingOffData: data.data
      }));
    }).catch(function (_ref2) {
      var response = _ref2.response;
      (0, _reactUtils.handleError)(response);
    });
  };
};

exports.getCoolingOffDuration = getCoolingOffDuration;